<template>
    <div class="mt-8">
        <v-layout wrap>
          <v-flex>
            <section>
              <!-- Configuration Section -->
              <v-card
                elevation="0"
                class="ma-4 mt-0 pa-5 box-shadow pb-5"
                style="border-radius: 15px; border: 1px solid #E7E7E7;">
                <v-row>
                    <v-col cols="6" class="py-0">
                        <div class="color-dark-blue fs-22 font-weight-bold">
                        Tambahkan Surat Jalan (AI)
                        </div>
                    </v-col>
                </v-row>
                <v-card-text class="pa-6">
                  <div class="d-flex align-center mb-4">
                    <v-icon class="mr-2">mdi-cog</v-icon>
                    <div class="fs-18 font-weight-bold">Konfigurasi Pengelompokan</div>
                  </div>

                  <!-- Filter Data BPB -->
                  <div class="mb-4">
                    <v-expansion-panels
                      v-model="filterPanel"
                      flat
                      tile>
                      <v-expansion-panel style="border: 1px solid #e0e0e0; border-radius: 8px;">
                        <v-expansion-panel-header class="pa-4">
                          <div class="d-flex align-center">
                            <v-icon class="mr-2">mdi-filter</v-icon>
                            <span class="font-weight-bold">Filter Data BPB</span>
                            <v-chip small :color="process.load ? 'secondary' : 'primary'" class="ml-2">
                              <v-icon 
                                v-if="process.load" 
                                left 
                                small 
                                class="rotating">
                                mdi-loading
                              </v-icon>
                              <v-icon 
                                v-else 
                                left 
                                small>
                                mdi-database
                              </v-icon>
                              {{ process.load ? 'Loading...' : `${filteredBpbCount} BPB ditemukan` }}
                            </v-chip>
                          </div>
                        </v-expansion-panel-header>
                        <v-expansion-panel-content class="pa-4 pt-0">
                          <v-row>
                            <!-- Supervisor Filter -->
                            <v-col cols="12" md="2" v-if="$store.state.user.category_user_title !== 'Supervisor'">
                              <div class="fs-14 font-weight-bold mb-2">Supervisor</div>
                              <v-autocomplete
                                v-model="filters.supervisor"
                                :items="supervisor"
                                item-text="name"
                                item-value="id"
                                clearable
                                @click:clear="filters.supervisor = null; fetchOrder();"
                                @change="fetchOrder(); fetchSales();"
                                placeholder="Semua Supervisor/Ahma..."
                                dense
                                outlined
                                hide-details
                                style="font-size: 12px;">
                              </v-autocomplete>
                            </v-col>

                            <!-- Sales Filter -->
                            <v-col cols="12" md="2">
                              <div class="fs-14 font-weight-bold mb-2">Sales</div>
                              <v-autocomplete
                                v-model="filters.sales"
                                :items="sales"
                                item-text="name"
                                item-value="name"
                                clearable
                                @click:clear="filters.sales = null; fetchOrder();"
                                @change="fetchOrder()"
                                placeholder="Semua Sales/Dedi Sales"
                                dense
                                outlined
                                hide-details
                                style="font-size: 12px;">
                              </v-autocomplete>
                            </v-col>

                            <!-- Province Filter -->
                            <v-col cols="12" md="2">
                              <div class="fs-14 font-weight-bold mb-2">Provinsi</div>
                              <v-autocomplete
                                v-model="filters.province"
                                :items="province"
                                item-text="name"
                                item-value="name"
                                clearable
                                @click:clear="filters.province = null; changeProvince();"
                                @change="changeProvince()"
                                placeholder="Semua Provinsi/Sumater..."
                                dense
                                outlined
                                hide-details
                                style="font-size: 12px;">
                              </v-autocomplete>
                            </v-col>

                            <!-- City Filter -->
                            <v-col cols="12" md="2">
                              <div class="fs-14 font-weight-bold mb-2">Kota</div>
                              <v-autocomplete
                                v-model="filters.city"
                                :items="city"
                                item-text="name"
                                item-value="name"
                                clearable
                                @click:clear="filters.city = null; changeCity();"
                                @change="changeCity()"
                                placeholder="Semua Kota/Palembang"
                                dense
                                outlined
                                hide-details
                                style="font-size: 12px;">
                              </v-autocomplete>
                            </v-col>

                            <!-- District Filter -->
                            <v-col cols="12" md="2">
                              <div class="fs-14 font-weight-bold mb-2">Kecamatan</div>
                              <v-autocomplete
                                v-model="filters.district"
                                :items="subdistrict"
                                item-text="name"
                                item-value="name"
                                clearable
                                @click:clear="filters.district = null; changeDistrict();"
                                @change="changeDistrict()"
                                placeholder="Semua Kecamatan/Ilir..."
                                dense
                                outlined
                                hide-details
                                style="font-size: 12px;">
                              </v-autocomplete>
                            </v-col>

                            <!-- Sub-district Filter -->
                            <v-col cols="12" md="2">
                              <div class="fs-14 font-weight-bold mb-2">Kelurahan</div>
                              <v-autocomplete
                                v-model="filters.subdistrict"
                                :items="village"
                                item-text="name"
                                item-value="name"
                                clearable
                                @click:clear="filters.subdistrict = null; fetchOrder();"
                                @change="fetchOrder()"
                                placeholder="Semua Kelurahan/Bukit..."
                                dense
                                outlined
                                hide-details
                                style="font-size: 12px;">
                              </v-autocomplete>
                            </v-col>
                          </v-row>

                          <v-row class="mt-2">
                            <v-col cols="12" class="d-flex justify-end">
                              <v-btn
                                @click="resetFilters"
                                outlined
                                small
                                class="mr-2">
                                Reset Filter
                              </v-btn>
                            </v-col>
                          </v-row>
                        </v-expansion-panel-content>
                      </v-expansion-panel>
                    </v-expansion-panels>

                    <v-expansion-panels
                      v-model="vehiclePanel"
                      flat
                      tile
                      class="mt-4">
                      <v-expansion-panel style="border: 1px solid #e0e0e0; border-radius: 8px;">
                        <v-expansion-panel-header class="pa-4">
                          <div class="d-flex align-center">
                            <v-icon class="mr-2">mdi-truck</v-icon>
                            <span class="font-weight-bold">Pilih Mobil</span>
                            <v-chip small :color="selectedVehicles.length > 0 ? 'success' : 'error'" class="ml-2"">
                              {{ selectedVehicles.length }} dari {{ vehicle.length }} mobil dipilih
                            </v-chip>
                          </div>
                        </v-expansion-panel-header>
                        <v-expansion-panel-content class="pa-4 pt-0">
                          <v-row>
                            <v-col cols="12">
                              <div class="fs-14 font-weight-bold mb-3">Pilih kendaraan yang akan digunakan untuk pengiriman</div>
                              
                              <!-- Vehicle Multi-Select -->
                              <v-autocomplete
                                v-model="selectedVehicles"
                                :items="vehicle"
                                item-value="id"
                                :item-text="item => `${item.name} - ${item.number}`"
                                multiple
                                chips
                                deletable-chips
                                placeholder="Pilih kendaraan..."
                                dense
                                outlined
                                hide-details
                                class="mb-3">
                                <template v-slot:selection="{ item, index }">
                                  <v-chip
                                    v-if="index < 2"
                                    color="primary"
                                    small
                                    close
                                    @click:close="removeVehicle(item)">
                                    <v-icon left small>mdi-truck</v-icon>
                                    {{ item.name }} - {{ item.number }} {{ item.volume ? `(${item.volume} cm)` : '' }}
                                  </v-chip>
                                  <span
                                    v-if="index === 2"
                                    class="grey--text text-caption">
                                    (+{{ selectedVehicles.length - 2 }} lainnya)
                                  </span>
                                </template>
                                <template v-slot:item="{ item, on, attrs }">
                                  <v-list-item v-on="on" v-bind="attrs">
                                    <v-list-item-action>
                                      <v-checkbox
                                        :input-value="selectedVehicles.includes(item.id)"
                                        color="primary">
                                      </v-checkbox>
                                    </v-list-item-action>
                                    <v-list-item-content>
                                      <v-list-item-title>
                                        <v-icon class="mr-2">mdi-truck</v-icon>
                                        {{ item.name }} - {{ item.number }}
                                      </v-list-item-title>
                                      <v-list-item-subtitle v-if="item.capacity">
                                        Kapasitas: {{ item.capacity }}
                                      </v-list-item-subtitle>
                                    </v-list-item-content>
                                  </v-list-item>
                                </template>
                              </v-autocomplete>

                              <!-- Selected Vehicles Display -->
                              <div v-if="selectedVehicles.length > 0" class="mt-3">
                                <div class="fs-14 font-weight-bold mb-2">Kendaraan Terpilih:</div>
                                <v-row>
                                  <v-col 
                                    v-for="vehicleId in selectedVehicles" 
                                    :key="vehicleId" 
                                    cols="12" md="6" lg="4">
                                    <v-card 
                                      outlined 
                                      class="pa-3"
                                      style="border-radius: 8px;">
                                      <div class="d-flex align-center justify-space-between">
                                        <div class="d-flex align-center">
                                          <v-icon color="primary" class="mr-2">mdi-truck</v-icon>
                                          <div>
                                            <div class="fs-12 font-weight-bold">
                                              {{ getVehicleById(vehicleId)?.name }}
                                            </div>
                                            <div class="fs-10" style="color: #666;">
                                              {{ getVehicleById(vehicleId)?.number }} {{ getVehicleById(vehicleId)?.volume ? `(${getVehicleById(vehicleId)?.volume} cm)` : '' }}
                                            </div>
                                          </div>
                                        </div>
                                        <v-btn
                                          @click="removeVehicleById(vehicleId)"
                                          icon
                                          small
                                          color="red">
                                          <v-icon size="16">mdi-close</v-icon>
                                        </v-btn>
                                      </div>
                                    </v-card>
                                  </v-col>
                                </v-row>
                              </div>

                              <!-- Action Buttons -->
                              <v-row class="mt-3">
                                <v-col cols="12" class="d-flex justify-end">
                                  <v-btn
                                    @click="clearSelectedVehicles"
                                    outlined
                                    small
                                    class="mr-2"
                                    :disabled="selectedVehicles.length === 0">
                                    Clear Semua
                                  </v-btn>
                                  <v-btn
                                    @click="selectAllVehicles"
                                    color="primary"
                                    small
                                    outlined
                                    :disabled="selectedVehicles.length === vehicle.length">
                                    Pilih Semua
                                  </v-btn>
                                </v-col>
                              </v-row>
                            </v-col>
                          </v-row>
                        </v-expansion-panel-content>
                      </v-expansion-panel>
                    </v-expansion-panels>
                  </div>

                  <!-- Algorithm Configuration -->
                  <div class="mb-4">
                    <v-expansion-panels
                      v-model="configPanel"
                      flat
                      tile
                      class="mt-4">
                      <v-expansion-panel style="border: 1px solid #e0e0e0; border-radius: 8px;">
                        <v-expansion-panel-header class="pa-4">
                          <div class="d-flex align-center">
                            <v-icon class="mr-2">mdi-tune</v-icon>
                            <span class="font-weight-bold">Konfigurasi Algoritma</span>
                          </div>
                        </v-expansion-panel-header>
                        <v-expansion-panel-content class="pa-4 pt-0">
                          <v-row>
                            <v-col cols="12" md="6">
                              <div class="fs-14 font-weight-bold mb-2">Kapasitas Maksimal (%)</div>
                              <v-text-field
                                v-model.number="algorithmConfig.maxCapacity"
                                type="number"
                                min="50"
                                max="100"
                                step="5"
                                dense
                                outlined
                                hide-details
                                suffix="%"
                                placeholder="85">
                              </v-text-field>
                              <div class="fs-10 mt-1" style="color: #666;">
                                Kapasitas maksimal kendaraan yang akan digunakan ({{ algorithmConfig.maxCapacity }}%)
                              </div>
                            </v-col>
                            <v-col cols="12" md="6">
                              <div class="fs-14 font-weight-bold mb-2">Maksimal BPB per Kendaraan</div>
                              <v-text-field
                                v-model.number="algorithmConfig.maxOrdersPerVehicle"
                                type="number"
                                min="1"
                                max="50"
                                step="1"
                                dense
                                outlined
                                hide-details
                                suffix="BPB"
                                placeholder="10">
                              </v-text-field>
                              <div class="fs-10 mt-1" style="color: #666;">
                                Maksimal {{ algorithmConfig.maxOrdersPerVehicle }} BPB per kendaraan
                              </div>
                            </v-col>
                          </v-row>
                        </v-expansion-panel-content>
                      </v-expansion-panel>
                    </v-expansion-panels>

                    <v-btn
                        @click="generateGroups"
                        :loading="process.generating"
                        :disabled="process.load || selectedVehicles.length === 0"
                        :color="process.load || selectedVehicles.length === 0 ? 'grey' : 'black'"
                        dark
                        block
                        class="text-capitalize mt-4"
                        style="height: 40px;">
                        <span v-if="process.load">Memuat Data BPB...</span>
                        <span v-else>Generate dengan AI</span>
                        <v-icon right>mdi-auto-fix</v-icon>
                    </v-btn>
                  </div>

                  <!-- Statistics Cards -->
                <v-row class="mb-6">
                    <v-col>
                    <v-card
                        elevation="0"
                        class="text-center pa-4"
                        style="border-radius: 12px; border: 1px solid #e0e0e0;">
                        <v-icon color="blue" size="24" class="mb-2">mdi-filter</v-icon>
                        <div class="fs-24 font-weight-bold color-primary">{{ statistics.filtered }}</div>
                        <div class="fs-12" style="color: #666;">BPB Terfilter</div>
                    </v-card>
                    </v-col>
                    <v-col>
                    <v-card
                        elevation="0"
                        class="text-center pa-4"
                        style="border-radius: 12px; border: 1px solid #e0e0e0;">
                        <v-icon color="green" size="24" class="mb-2">mdi-group</v-icon>
                        <div class="fs-24 font-weight-bold color-success">{{ statistics.groups }}</div>
                        <div class="fs-12" style="color: #666;">Kelompok</div>
                    </v-card>
                    </v-col>
                    <v-col>
                    <v-card
                        elevation="0"
                        class="text-center pa-4"
                        style="border-radius: 12px; border: 1px solid #e0e0e0;">
                        <v-icon color="orange" size="24" class="mb-2">mdi-alert-circle</v-icon>
                        <div class="fs-24 font-weight-bold color-warning">{{ statistics.unassigned }}</div>
                        <div class="fs-12" style="color: #666;">BPB Belum Assign</div>
                    </v-card>
                    </v-col>
                    <v-col>
                    <v-card
                        elevation="0"
                        class="text-center pa-4"
                        style="border-radius: 12px; border: 1px solid #e0e0e0;">
                        <v-icon color="purple" size="24" class="mb-2">mdi-truck</v-icon>
                        <div class="fs-24 font-weight-bold color-purple">{{ selectedVehicles.length }}</div>
                        <div class="fs-12" style="color: #666;">Mobil Tersedia</div>
                    </v-card>
                    </v-col>
                    <v-col>
                    <v-card
                        elevation="0"
                        class="text-center pa-4"
                        style="border-radius: 12px; border: 1px solid #e0e0e0;">
                        <v-icon color="red" size="24" class="mb-2">mdi-check-circle</v-icon>
                        <div class="fs-24 font-weight-bold color-error">{{ statistics.assigned }}</div>
                        <div class="fs-12" style="color: #666;">Sudah Assign</div>
                    </v-card>
                    </v-col>
                </v-row>

                <!-- Generated Groups -->
                <div v-if="generatedGroups.length > 0">
                    <div
                    v-for="(group, index) in generatedGroups"
                    :key="index"
                    class="mb-6">
                    
                    <!-- Group Header -->
                    <v-card
                        elevation="0"
                        style="border-radius: 15px; border: 1px solid #E7E7E7;">
                        <v-card-text class="pa-4">
                        <div class="d-flex align-center justify-space-between mb-4">
                            <div class="d-flex align-center">
                            <v-icon color="primary" class="mr-2">mdi-map-marker</v-icon>
                            <div>
                                <div class="fs-18 font-weight-bold">{{ group.name }}</div>
                                <div class="fs-12" style="color: #666;">
                                <v-icon small class="mr-1">mdi-cube</v-icon>
                                {{ group.bpbCount }} BPB
                                <v-icon small class="mr-1 ml-2">mdi-package-variant</v-icon>
                                {{ group.totalVolume || '0/0 products' }}
                                </div>
                            </div>
                            </div>
                            <div class="d-flex align-center">
                            <div class="text-right mr-4">
                                <div class="fs-12" style="color: #666;">Kapasitas:</div>
                                <div class="fs-16 font-weight-bold" :style="{ color: group.capacity >= 100 ? 'red' : 'inherit' }">{{ Math.round(group.capacity) }}%</div>
                            </div>
                            </div>
                        </div>

                        <!-- BPB List Table -->
                        <div class="mb-4">
                            <div class="d-flex align-center justify-space-between mb-3">
                            <div class="fs-14 font-weight-bold">Daftar BPB dalam Kelompok</div>
                            <v-btn
                                small
                                color="primary"
                                outlined
                                :disabled="selected_suratjalan.includes(index)"
                                @click="openAddBpbModal(group, index)"
                                class="text-capitalize">
                                <v-icon left size="16">mdi-plus</v-icon>
                                Tambah BPB
                            </v-btn>
                            </div>

                            <v-simple-table dense>
                            <template v-slot:default>
                                <thead>
                                <tr style="background: #f5f5f5;">
                                    <th class="text-left fs-12 font-weight-bold pa-2">BPB ID</th>
                                    <th class="text-left fs-12 font-weight-bold pa-2">Customer</th>
                                    <th class="text-left fs-12 font-weight-bold pa-2">Alamat</th>
                                    <th class="text-left fs-12 font-weight-bold pa-2">Order Time</th>
                                    <th class="text-left fs-12 font-weight-bold pa-2">Sales</th>
                                    <th class="text-left fs-12 font-weight-bold pa-2">Dimensi</th>
                                    <th class="text-left fs-12 font-weight-bold pa-2">Aksi</th>
                                </tr>
                                </thead>
                                <tbody>
                                <tr
                                    v-for="(bpb, bpbIndex) in group.bpbList"
                                    :key="bpbIndex">
                                    <td style="font-size: 12px !important;">{{ bpb.id }}</td>
                                    <td style="font-size: 12px !important;">{{ bpb.customer }}</td>
                                    <td style="font-size: 12px !important; max-width: 200px;">{{ bpb.address }}</td>
                                    <td style="font-size: 12px !important;">{{ bpb.order_input_datetime }}</td>
                                    <td style="font-size: 12px !important;">{{ bpb.sales }}</td>
                                    <td style="font-size: 12px !important;">{{ bpb.dimensions }}</td>
                                    <td class="fs-12 pa-2">
                                    <v-btn
                                        @click="removeBpbFromGroup(index, bpbIndex)"
                                        icon
                                        :disabled="selected_suratjalan.includes(index)"
                                        small
                                        color="red">
                                        <v-icon size="16">mdi-close</v-icon>
                                    </v-btn>
                                    </td>
                                </tr>
                                </tbody>
                            </template>
                            </v-simple-table>
                        </div>

                        <!-- Assignment Details -->
                        <div class="fs-14 font-weight-bold mb-3">Assignment Details</div>
                        <v-row>
                            <v-col cols="12" md="6">
                            <div class="fs-12 font-weight-bold mb-2">Kendaraan</div>
                            <v-autocomplete
                                v-model="group.selectedVehicle"
                                :items="vehicle"
                                item-value="id"
                                :item-text="item => `${item.name} - ${item.number}`"
                                placeholder="Mobil Box 1 - B 1234 CD"
                                dense
                                :disabled="selected_suratjalan.includes(index)"
                                outlined
                                hide-details>
                                <template v-slot:selection="{ item }">
                                <div class="d-flex align-center">
                                    <v-icon small class="mr-2">mdi-truck</v-icon>
                                    {{ item.name }} - {{ item.number }}
                                </div>
                                </template>
                                <template v-slot:item="{ item }">
                                  <v-list-item-content>
                                    <v-list-item-title>{{ item.name }} - {{ item.number }}</v-list-item-title>
                                  </v-list-item-content>
                                </template>
                            </v-autocomplete>
                            </v-col>
                            <v-col cols="12" md="6">
                            <div class="fs-12 font-weight-bold mb-2">Driver</div>
                            <v-autocomplete
                                v-model="group.selectedDriver"
                                :items="driver"
                                item-text="name"
                                item-value="id"
                                placeholder="Pilih Nama Driver"
                                dense
                                :disabled="selected_suratjalan.includes(index)"
                                outlined
                                hide-details>
                                <template v-slot:selection="{ item }">
                                <div>
                                    <div class="fs-12 font-weight-bold">{{ item.name }}</div>
                                    <div class="fs-10" style="color: #666;">Driver • {{ item.phone || 'No Phone' }}</div>
                                </div>
                                </template>
                            </v-autocomplete>
                            </v-col>
                        </v-row>

                        <v-row class="mt-3">
                            <v-col cols="12" md="6">
                            <div class="fs-12 font-weight-bold mb-2">Tanggal Kirim</div>
                            <v-text-field
                                v-model="group.deliveryDate"
                                type="date"
                                dense
                                :disabled="selected_suratjalan.includes(index)"
                                outlined
                                hide-details>
                            </v-text-field>
                            </v-col>
                            <v-col cols="12" md="6">
                            <div class="fs-12 font-weight-bold mb-2">Status Assignment</div>
                            <v-chip
                                :color="group.status === 'Complete' ? 'green' : 'orange'"
                                small
                                class="mt-2">
                                {{ group.status }}
                            </v-chip>
                            </v-col>
                        </v-row>

                        <v-row class="mt-3">
                            <v-col cols="12">
                            <div class="fs-12 font-weight-bold mb-2">Catatan</div>
                            <v-textarea
                                v-model="group.notes"
                                placeholder="Tambahkan catatan khusus untuk pengiriman ini..."
                                dense
                                :disabled="selected_suratjalan.includes(index)"
                                outlined
                                rows="2"
                                hide-details>
                            </v-textarea>
                            </v-col>
                        </v-row>

                        <!-- Route Map Button -->
                        <v-row class="mt-4">
                            <v-col cols="12" class="d-flex justify-end">
                              <v-btn
                                @click="toAddSurajJalan(group, index); selected_id = index"
                                color="primary"
                                elevation="0"
                                small
                                :loading="process.form && selected_id === index"
                                :disabled="selected_suratjalan.includes(index)"
                                class="text-capitalize mr-2">
                                <v-icon left size="16">mdi-plus</v-icon>
                                {{ selected_suratjalan.includes(index) ? 'Sudah Ditambahkan' : 'Buat Surat Jalan' }}
                              </v-btn>
                            <v-btn
                                @click="showRouteMap(group, index)"
                                color="primary"
                                outlined
                                small
                                class="text-capitalize">
                                <v-icon left size="16">mdi-map</v-icon>
                                Lihat Rute di Peta
                            </v-btn>
                            </v-col>
                        </v-row>
                        </v-card-text>
                    </v-card>
                    </div>

                </div>

                <!-- Empty State -->
                <div v-else class="text-center py-12">
                    <v-icon size="64" color="grey lighten-1">mdi-truck-outline</v-icon>
                    <div class="fs-16 mt-4 font-weight-bold" style="color: #666;">
                    Belum ada kelompok yang dihasilkan
                    </div>
                    <div class="fs-14 mt-2" style="color: #999;">
                    Atur filter dan konfigurasi, lalu klik "Generate Kelompok" untuk memulai
                    </div>
                </div >
                </v-card-text>
              </v-card>

              
            </section>
          </v-flex>
        </v-layout>

      <!-- Route Map Modal -->
      <v-dialog
        v-model="routeMapDialog"
        max-width="1200px"
        persistent>
        <v-card v-if="selectedGroupForMap">
          <v-card-title class="d-flex align-center justify-space-between">
            <div class="d-flex align-center">
              <v-icon class="mr-2">mdi-map</v-icon>
              <span>Peta Rute: {{ selectedGroupForMap?.name }}</span>
            </div>
            <v-btn
              @click="closeRouteMap"
              icon
              color="grey">
              <v-icon>mdi-close</v-icon>
            </v-btn>
          </v-card-title>
          
          <v-card-text class="pa-0">
            <!-- Route Statistics -->
            <div class="pa-4 pb-0">
              <v-row class="mb-4">
                <v-col cols="12" md="3">
                  <v-card class="text-center pa-3" color="primary" dark>
                    <div class="headline">{{ selectedGroupForMap?.bpbList?.length || 0 }}</div>
                    <div class="caption">Total Tujuan</div>
                  </v-card>
                </v-col>
                <v-col cols="12" md="3">
                  <v-card class="text-center pa-3" color="success" dark>
                    <div class="headline">{{ selectedGroupForMap ? (calculateRouteDistance() / 1000).toFixed(1) : 0 }} km</div>
                    <div class="caption">Total Jarak</div>
                  </v-card>
                </v-col>
                <v-col cols="12" md="3">
                  <v-card class="text-center pa-3" color="info" dark>
                    <div class="headline">{{ selectedGroupForMap ? selectedGroupForMap.totalVolume : 'N/A' }}</div>
                    <div class="caption">Products Loaded</div>
                  </v-card>
                </v-col>
                <v-col cols="12" md="3">
                  <v-card class="text-center pa-3" color="warning" dark>
                    <div class="headline">{{ selectedGroupForMap?.vehicleName || 'N/A' }}</div>
                    <div class="caption">{{ selectedGroupForMap?.vehicleDimensions || 'Kendaraan' }}</div>
                  </v-card>
                </v-col>
              </v-row>
            </div>

            <!-- Map Container -->
            <div 
              id="route-map" 
              style="height: 500px; width: 100%;">
            </div>
            
            <!-- Route Details -->
            <div class="pa-4">
              <div class="fs-14 font-weight-bold mb-3">Detail Rute Pengiriman</div>
              <v-simple-table dense>
                <template v-slot:default>
                  <thead>
                    <tr style="background: #f5f5f5;">
                      <th class="text-left fs-12 font-weight-bold pa-2">Urutan</th>
                      <th class="text-left fs-12 font-weight-bold pa-2">Lokasi</th>
                      <th class="text-left fs-12 font-weight-bold pa-2">Customer</th>
                      <th class="text-left fs-12 font-weight-bold pa-2">Alamat</th>
                      <th class="text-left fs-12 font-weight-bold pa-2">Koordinat</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr style="background: #e3f2fd;">
                      <td class="fs-12 pa-2">
                        <v-chip small color="green" dark>
                          <v-icon left size="12">mdi-home</v-icon>
                          Start
                        </v-chip>
                      </td>
                      <td class="fs-12 pa-2 font-weight-bold">Origin (Gudang)</td>
                      <td class="fs-12 pa-2">-</td>
                      <td class="fs-12 pa-2">Palembang, Sumatera Selatan</td>
                      <td class="fs-12 pa-2">{{ originLocation.latitude }}, {{ originLocation.longitude }}</td>
                    </tr>
                    <tr 
                      v-for="(bpb, index) in selectedGroupForMap?.bpbList || []"
                      :key="index">
                      <td class="fs-12 pa-2">
                        <v-chip small color="primary" dark>
                          <v-icon left size="12">mdi-numeric-{{ index + 1 }}-box</v-icon>
                          {{ index + 1 }}
                        </v-chip>
                      </td>
                      <td class="fs-12 pa-2">{{ bpb.id }}</td>
                      <td class="fs-12 pa-2">{{ bpb.customer }}</td>
                      <td class="fs-12 pa-2" style="max-width: 200px;">{{ bpb.address }}</td>
                      <td class="fs-12 pa-2">{{ bpb.coordinates?.lat || 'N/A' }}, {{ bpb.coordinates?.lng || 'N/A' }}</td>
                    </tr>
                  </tbody>
                </template>
              </v-simple-table>
            </div>
          </v-card-text>
          
          <v-card-actions class="pa-4">
            <v-spacer></v-spacer>
            <v-btn
              @click="closeRouteMap"
              color="grey"
              outlined
              class="text-capitalize">
              Tutup
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>

              <!-- Success Snackbar -->
      <v-snackbar
        v-model="showSuccess"
        color="success"
        timeout="4000"
        bottom>
        {{ message.success }}
        <template v-slot:action="{ attrs }">
          <v-btn
            color="white"
            text
            v-bind="attrs"
            @click="showSuccess = false">
            Tutup
          </v-btn>
        </template>
      </v-snackbar>

      <!-- Error Snackbar -->
      <v-snackbar
        v-model="showError"
        color="error"
        timeout="6000"
        bottom>
        {{ message.error }}
        <template v-slot:action="{ attrs }">
          <v-btn
            color="white"
            text
            v-bind="attrs"
            @click="showError = false">
            Tutup
          </v-btn>
        </template>
      </v-snackbar>

      <!-- Add BPB Modal -->
      <v-dialog
        v-model="addBpbDialog"
        max-width="1000px"
        persistent>
        <v-card v-if="selectedGroupForAddBpb">
          <v-card-title class="d-flex align-center justify-space-between">
            <div class="d-flex align-center">
              <v-icon class="mr-2">mdi-plus-circle</v-icon>
              <span>Tambah BPB ke {{ selectedGroupForAddBpb?.name }}</span>
            </div>
            <v-btn
              @click="closeAddBpbModal"
              icon
              color="grey">
              <v-icon>mdi-close</v-icon>
            </v-btn>
          </v-card-title>
          
          <v-card-text class="pa-0">
            <!-- Search and Filter -->
            <div class="pa-4 pb-0">
              <v-row>
                <v-col cols="12" md="6">
                  <v-text-field
                    v-model="addBpbSearch"
                    placeholder="Cari BPB, customer, atau alamat..."
                    prepend-inner-icon="mdi-magnify"
                    dense
                    outlined
                    hide-details
                    clearable>
                  </v-text-field>
                </v-col>
                <v-col cols="12" md="6" class="d-flex align-center">
                  <div class="fs-14">
                    <v-icon small class="mr-1">mdi-information</v-icon>
                    {{ filteredUnassignedOrders.length }} BPB belum diassign
                  </div>
                </v-col>
              </v-row>
            </div>

            <!-- Unassigned Orders Table -->
            <div class="pa-4">
              <v-simple-table dense max-height="400px" style="overflow-y: auto;">
                <template v-slot:default>
                  <thead>
                    <tr style="background: #f5f5f5;">
                      <th class="text-left fs-12 font-weight-bold pa-2">
                        <v-checkbox
                          v-model="selectAllUnassigned"
                          @change="toggleSelectAllUnassigned"
                          color="primary"
                          hide-details>
                        </v-checkbox>
                      </th>
                      <th class="text-left fs-12 font-weight-bold pa-2">BPB ID</th>
                      <th class="text-left fs-12 font-weight-bold pa-2">Customer</th>
                      <th class="text-left fs-12 font-weight-bold pa-2">Alamat</th>
                      <th class="text-left fs-12 font-weight-bold pa-2">Order Time</th>
                      <th class="text-left fs-12 font-weight-bold pa-2">Sales</th>
                      <th class="text-left fs-12 font-weight-bold pa-2">Dimensi</th>
                      <th class="text-left fs-12 font-weight-bold pa-2">Fitting</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr
                      v-for="order in filteredUnassignedOrders"
                      :key="order.id"
                      :class="{ 'bg-light-blue-1': selectedOrdersToAdd.includes(order.number) }">
                      <td class="fs-12 pa-2">
                        <v-checkbox
                          v-model="selectedOrdersToAdd"
                          :value="order.number"
                          color="primary"
                          hide-details>
                        </v-checkbox>
                      </td>
                      <td style="font-size: 12px !important;">{{ order.number }}</td>
                      <td style="font-size: 12px !important;">{{ order.store_name }}</td>
                      <td style="font-size: 12px !important; max-width: 200px;">
                        {{ order.customer_shipping_province }}, {{ order.customer_shipping_city }}
                      </td>
                      <td style="font-size: 12px !important;">{{ order.order_input_datetime || 'N/A' }}</td>
                      <td style="font-size: 12px !important;">{{ order.sales_name || 'N/A' }}</td>
                      <td style="font-size: 12px !important;">
                        <div v-if="order.bpb_detail && order.bpb_detail.length > 0">
                          <div v-for="detail in order.bpb_detail.slice(0, 2)" :key="detail.id" class="fs-10">
                            {{ getQuantityText(detail) }} - {{ detail.varian_volume || 'N/A' }}
                          </div>
                          <div v-if="order.bpb_detail.length > 2" class="fs-10 grey--text">
                            +{{ order.bpb_detail.length - 2 }} lainnya
                          </div>
                        </div>
                        <span v-else class="grey--text">N/A</span>
                      </td>
                      <td style="font-size: 12px !important;">
                        <v-chip
                          :color="checkOrderFitting(order) ? 'green' : 'red'"
                          small
                          dark>
                          <v-icon left size="12">
                            {{ checkOrderFitting(order) ? 'mdi-check' : 'mdi-close' }}
                          </v-icon>
                          {{ checkOrderFitting(order) ? 'Fit' : 'No Fit' }}
                        </v-chip>
                      </td>
                    </tr>
                  </tbody>
                </template>
              </v-simple-table>
              
              <!-- Empty State -->
              <div v-if="filteredUnassignedOrders.length === 0" class="text-center py-8">
                <v-icon size="48" color="grey lighten-1">mdi-package-variant</v-icon>
                <div class="fs-14 mt-2 grey--text">
                  {{ addBpbSearch ? 'Tidak ada BPB yang sesuai dengan pencarian' : 'Semua BPB sudah diassign ke kelompok' }}
                </div>
              </div>
            </div>
          </v-card-text>
          
          <v-card-actions class="pa-4">
            <div class="fs-12">
              {{ selectedOrdersToAdd.length }} BPB dipilih
            </div>
            <v-spacer></v-spacer>
            <v-btn
              @click="closeAddBpbModal"
              color="grey"
              outlined
              class="text-capitalize mr-2">
              Batal
            </v-btn>
            <v-btn
              @click="addSelectedOrdersToGroup"
              :disabled="selectedOrdersToAdd.length === 0"
              color="primary"
              class="text-capitalize white--text">
              Tambah {{ selectedOrdersToAdd.length }} BPB
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
      </div>
</template>

<script>
import { get, post } from "@/service/Axios";

export default {
  data() {
    return {
      originLocation: {
        latitude: -2.919954,
        longitude: 104.645430
      },
      filterPanel: 0,
      
      // Filters
      filters: {
        supervisor: null,
        sales: null,
        province: null,
        city: null,
        district: null,
        subdistrict: null
      },

      // Algorithm Configuration
      algorithmConfig: {
        maxDistance: 5,
        maxCapacity: 90,
        maxOrdersPerVehicle: 6
      },

      // Statistics
      statistics: {
        filtered: 0,
        groups: 0,
        unassigned: 0,
        vehicles: 0,
        assigned: 0
      },

      // Data Arrays - Following main form structure
      supervisor: [],
      sales: [],
      salesAll: [],
      province: [],
      city: [],
      subdistrict: [],
      village: [],
      vehicle: [],
      driver: [],
      order: [],

      // Generated Groups
      generatedGroups: [],

      // Process States
      process: {
        generating: false,
        confirming: false,
        load: false,
        form: false
      },

      // Messages
      message: {
        success: '',
        error: ''
      },
      showSuccess: false,
      showError: false,
      vehiclePanel: 0,
      selectedVehicles: [],
      configPanel: 0,
      routeMapDialog: false,
      selectedGroupForMap: null,
      map: null,
      addBpbDialog: false,
      selectedGroupForAddBpb: null,
      addBpbSearch: '',
      selectAllUnassigned: false,
      selectedOrdersToAdd: [],
      selected_suratjalan: [],
      selected_id: ''
    }

  },

  computed: {
    filteredBpbCount() {
      return this.order.length;
    },
    set_color() {
      return this.$store.state.color;
    },
    filteredUnassignedOrders() {
      // Get all assigned order IDs from all groups
      const assignedOrderIds = [];
      this.generatedGroups.forEach(group => {
        if (group.bpbList) {
          group.bpbList.forEach(bpb => {
            assignedOrderIds.push(bpb.id);
          });
        }
      });

      // Filter orders that are not assigned to any group
      let unassignedOrders = this.order.filter(order => 
        !assignedOrderIds.includes(order.number)
      );

      // Apply search filter if search term exists
      if (this.addBpbSearch && this.addBpbSearch.trim() !== '') {
        const searchTerm = this.addBpbSearch.toLowerCase();
        unassignedOrders = unassignedOrders.filter(order => 
          order.number.toLowerCase().includes(searchTerm) ||
          order.store_name.toLowerCase().includes(searchTerm) ||
          (order.customer_shipping_province && order.customer_shipping_province.toLowerCase().includes(searchTerm)) ||
          (order.customer_shipping_city && order.customer_shipping_city.toLowerCase().includes(searchTerm)) ||
          (order.sales_name && order.sales_name.toLowerCase().includes(searchTerm))
        );
      }

      return unassignedOrders;
    }
  },

  watch: {
    // Watch for changes in generated groups to set up deep watchers for vehicle/driver assignments
    generatedGroups: {
      handler(newGroups) {
        // Set up watchers for each group's vehicle and driver assignments
        newGroups.forEach((group, index) => {
          // Watch for vehicle assignment changes
          this.$watch(`generatedGroups.${index}.selectedVehicle`, (newVehicle, oldVehicle) => {
            if (newVehicle !== oldVehicle) {
              console.log(`🚛 Vehicle assignment changed for group ${index}: ${oldVehicle} → ${newVehicle}`);
              this.updateGroupStatistics(index);
            }
          });

          // Watch for driver assignment changes
          this.$watch(`generatedGroups.${index}.selectedDriver`, (newDriver, oldDriver) => {
            if (newDriver !== oldDriver) {
              console.log(`👤 Driver assignment changed for group ${index}: ${oldDriver} → ${newDriver}`);
              this.updateGroupStatistics(index);
            }
          });
        });
      },
      immediate: true,
      deep: true
    }
  },

  mounted() {
    this.loadMapLibreGL();
    this.fetchSupervisor();
    this.fetchSales();
    this.fetchVehicle();
    this.fetchDriver();
    this.fetchProv();
    this.fetchOrder();
  },

  methods: {
    // Load MapLibre GL dynamically
    loadMapLibreGL() {
      // Load MapLibre GL CSS
      const link = document.createElement('link');
      link.rel = 'stylesheet';
      link.href = 'https://unpkg.com/maplibre-gl@3.6.2/dist/maplibre-gl.css';
      document.head.appendChild(link);

      // Load MapLibre GL JS
      const script = document.createElement('script');
      script.src = 'https://unpkg.com/maplibre-gl@3.6.2/dist/maplibre-gl.js';
      script.onload = () => {
        console.log('MapLibre GL loaded successfully');
      };
      document.head.appendChild(script);
    },

    // Fetch Methods - Following exact patterns from main form
    async fetchSales() {
      let params = {
        'category_user_id[eq]': '8',
        limit: 1000000,
        is_active: 'Aktif',
        spv_id: this.$store.state.user.category_user_title === 'Supervisor' ? this.$store.state.user.id : '',
      }

      await get(`admin/user/data`, { params })
      .then(response => {
        let res = response.data
          
        if (res.status === 200) {
          this.sales = res.results.data
          this.salesAll = res.results.data
          if(this.filters.supervisor !== '' && this.filters.supervisor !== null && this.filters.supervisor !== undefined) {
            this.sales = this.salesAll.filter(sales => sales.spv_id === this.filters.supervisor)
          }
        }
      })
    },

    async fetchSupervisor() {
      let params = {
        'category_user_id[eq]': '5',
        limit: 1000000,
        is_active: 'Aktif',
      }

      await get(`admin/user/data`, { params })
      .then(response => {
        let res = response.data
          
        if (res.status === 200) {
          this.supervisor = res.results.data
        }
      })
    },

    async fetchProv() {
      let params = {
        limit: 10000000000000
      }

      await get(`ref/provinsi`, { params })
      .then(response => {
        let res = response.data
        
        if (res.status === 200) {
          this.province = res.results.data
        }
      })
    },

    changeProvince() {
      this.filters.city = null
      this.filters.district = null
      this.filters.subdistrict = null
      let id = ''
      this.province.map(obj => {
        if (obj.name === this.filters.province) {
          id = obj.id
        }
      })
      this.fetchOrder()
      this.fetchCity(id)
    },

    async fetchCity(id) {
      let params = {
        limit: 10000000000000,
        province_id: id
      }

      await get(`ref/kota`, { params })
      .then(response => {
        let res = response.data
        
        if (res.status === 200) {
          this.city = res.results.data
        }
      })
    },

    changeCity() {
      this.filters.district = null
      this.filters.subdistrict = null
      let id = ''
      this.city.map(obj => {
        if (obj.name === this.filters.city) {
          id = obj.id
        }
      })
      this.fetchOrder()
      this.fetchSub(id)
    },

    async fetchSub(id) {
      let params = {
        limit: 10000000000000,
        city_id: id
      }

      await get(`ref/kecamatan`, { params })
      .then(response => {
        let res = response.data
        
        if (res.status === 200) {
          this.subdistrict = res.results.data
        }
      })
    },

    changeDistrict() {
      this.filters.subdistrict = null
      let id = ''
      this.subdistrict.map(obj => {
        if (obj.name === this.filters.district) {
          id = obj.id
        }
      })
      this.fetchOrder()
      this.fetchVil(id)
    },

    async fetchVil(id) {
      let params = {
        limit: 10000000000000,
        subdistrict_id: id
      }

      await get(`ref/kelurahan`, { params })
      .then(response => {
        let res = response.data
        
        if (res.status === 200) {
          this.village = res.results.data
        }
      })
    },

    async fetchOrder() {
      this.process.load = true

      try {
        let params = {
          limit: 1000000,
          is_delivery: '0',
          customer_shipping_province: this.filters.province,
          customer_shipping_city: this.filters.city,
          customer_shipping_subdistrict: this.filters.district,
          customer_shipping_village: this.filters.subdistrict,
          spv_id: this.$store.state.user.category_user_title === 'Supervisor' ? this.$store.state.user.id : this.filters.supervisor,
          sales_name: this.filters.sales,
          sort: '-order_input_datetime'
        }

        const response = await get(`admin/bpb/data`, { params });
        let res = response.data
          
        if (res.status === 200) {
          this.order = res.results.data
          this.updateStatistics()
        }
      } catch (error) {
        console.error('Error fetching orders:', error);
        this.message.error = 'Gagal memuat data BPB';
        this.showError = true;
      } finally {
        this.process.load = false
      }
    },

    async fetchVehicle() {
      let params = {
        limit: 10000000,
      }

      await get(`admin/vehicle/data`, { params })
      .then(response => {
        let res = response.data
          
        if (res.status === 200) {
          this.vehicle = res.results.data
          this.statistics.vehicles = res.results.data.length
        }
      })
    },

    async fetchDriver() {
      let params = {
        limit: 10000000,
        'category_user_id[eq]': '11',
        is_active: 'Aktif',
      }

      await get(`admin/user/data`, { params })
      .then(response => {
        let res = response.data
          
        if (res.status === 200) {
          this.driver = res.results.data
        }
      })
    },

    updateStatistics() {
      this.statistics.filtered = this.order.length
      this.statistics.groups = this.generatedGroups.length
      this.statistics.unassigned = this.order.length - this.statistics.assigned
    },

    resetFilters() {
      this.filters = {
        supervisor: null,
        sales: null,
        province: null,
        city: null,
        district: null,
        subdistrict: null
      };
      this.city = []
      this.subdistrict = []
      this.village = []
      this.sales = this.salesAll
      this.fetchOrder()
    },

    async generateGroups() {
      if (this.selectedVehicles.length === 0 || this.process.load) {
        return;
      }

      this.process.generating = true;
      
      try {
        if (this.order.length === 0) {
          this.message.error = 'Tidak ada BPB yang ditemukan untuk dikelompokkan';
          this.showError = true;
          return;
        }

        // Simulate AI processing
        await new Promise(resolve => setTimeout(resolve, 2000));

        // Step 1: Calculate distance matrix using haversine
        const { matrix, allPoints } = await this.calculateDistanceMatrix(this.order);
        
        // Step 2: Use new vehicle-focused route-based algorithm
        const finalGroups = this.createVehicleBasedGroups(matrix, allPoints, this.selectedVehicles);
        
        this.generatedGroups = finalGroups;
        this.updateStatistics();
        this.statistics.groups = finalGroups.length;

        this.message.success = `Berhasil menghasilkan ${finalGroups.length} kelompok berdasarkan rute optimal untuk ${this.selectedVehicles.length} kendaraan dari ${this.order.length} BPB!`;
        this.showSuccess = true;
        
      } catch (error) {
        console.error('Error generating groups:', error);
        this.message.error = 'Terjadi kesalahan saat menghasilkan kelompok';
        this.showError = true;
      } finally {
        this.process.generating = false;
      }
    },

    // NEW: Vehicle-focused route-based grouping algorithm
    createVehicleBasedGroups(matrix, allPoints, selectedVehicles) {
      console.log('Starting vehicle-focused route-based grouping...');
      console.log(`Processing ${allPoints.length - 1} orders for ${selectedVehicles.length} vehicles`);
      console.log(`🔧 Algorithm Config: Max Distance: ${this.algorithmConfig.maxDistance}km, Max Capacity: ${this.algorithmConfig.maxCapacity}%, Max Orders: ${this.algorithmConfig.maxOrdersPerVehicle}`);
      
      const finalGroups = [];
      const today = new Date().toISOString().substr(0, 10);
      let groupCounter = 1;
      
      // Get all order points (excluding origin at index 0)
      const orderPoints = allPoints.slice(1); // Remove origin
      const availableOrders = [...orderPoints]; // Copy for manipulation
      
      // Process each selected vehicle
      for (let vehicleIndex = 0; vehicleIndex < selectedVehicles.length; vehicleIndex++) {
        if (availableOrders.length === 0) {
          console.log('No more orders to assign');
          break;
        }
        
        const vehicleId = selectedVehicles[vehicleIndex];
        const vehicle = this.vehicle.find(v => v.id === vehicleId);
        
        if (!vehicle) {
          console.warn(`⚠️ Vehicle with ID ${vehicleId} not found, skipping...`);
          continue;
        }
        
        // Get vehicle fitting capacity
        const vehicleDimsCm = this.getVehicleDimensionsCm(vehicleId);
        
        // Calculate maximum products that can fit
        const avgProductDims = { length: 29, width: 42, height: 15 };
        const maxFitResult = this.calculateFit(vehicleDimsCm, avgProductDims);
        const maxProductsCapacity = maxFitResult.totalFit;
        const maxAllowedProducts = Math.floor(maxProductsCapacity * this.algorithmConfig.maxCapacity / 100);
        
        console.log(`\n🚛 Processing Vehicle ${vehicleIndex + 1}: ${vehicle.name}`);
        console.log(`   📏 Dimensions: ${vehicleDimsCm.length}×${vehicleDimsCm.width}×${vehicleDimsCm.height}cm`);
        console.log(`   🎯 Max Products: ${maxProductsCapacity}, Max Allowed (${this.algorithmConfig.maxCapacity}%): ${maxAllowedProducts}`);
        console.log(`   📦 Max Orders: ${this.algorithmConfig.maxOrdersPerVehicle}`);
        
        // Create group for this vehicle
        const vehicleGroup = this.createVehicleGroup(
          groupCounter++,
          vehicleId,
          vehicle,
          null, // vehicleCapacity not used anymore
          maxAllowedProducts,
          today
        );
        
        // Fill this vehicle using route-based selection
        this.fillVehicleWithRouteOptimization(vehicleGroup, availableOrders, matrix, allPoints);
        
        // Only add group if it has orders
        if (vehicleGroup.bpbList?.length > 0) {
          finalGroups.push(vehicleGroup);
          console.log(`✅ Vehicle ${vehicle.name} assigned ${vehicleGroup.bpbList.length} orders (${vehicleGroup.capacity.toFixed(1)}% capacity)`);
        } else {
          console.log(`⚠️ Vehicle ${vehicle.name} could not be assigned any orders (capacity/order constraints)`);
        }
      }
      
      // Handle any remaining unassigned orders
      if (availableOrders.length > 0) {
        console.log(`\n⚠️ ${availableOrders.length} orders remain unassigned - creating overflow groups`);
        this.handleOverflowOrders(availableOrders, selectedVehicles, finalGroups, groupCounter, matrix, allPoints, today);
      }
      
      console.log(`\n🎯 Final result: ${finalGroups.length} vehicle groups created`);
      return finalGroups;
    },

    // Fill a vehicle using route optimization (nearest neighbor from previous order)
    fillVehicleWithRouteOptimization(vehicleGroup, availableOrders, matrix, allPoints) {
      const maxOrders = this.algorithmConfig.maxOrdersPerVehicle;
      let orderCount = 0;
      let totalProductsInVehicle = 0;
      
      // Get vehicle fitting capacity
      const vehicleDimsCm = this.getVehicleDimensionsCm(vehicleGroup.vehicleId);
      
      // Calculate maximum products that can fit in vehicle (using average product size)
      const avgProductDims = { length: 29, width: 42, height: 15 };
      const maxFitResult = this.calculateFit(vehicleDimsCm, avgProductDims);
      const maxProductsCapacity = maxFitResult.totalFit;
      const maxAllowedProducts = Math.floor(maxProductsCapacity * this.algorithmConfig.maxCapacity / 100);
      
      // Start from origin (index 0 in allPoints)
      let lastAssignedIndex = 0; // Origin index
      
      console.log(`  📍 Starting route from origin for ${vehicleGroup.vehicleName}`);
      console.log(`  🚛 Vehicle dimensions: ${vehicleDimsCm.length}×${vehicleDimsCm.width}×${vehicleDimsCm.height}cm`);
      console.log(`  📦 Max capacity: ${maxProductsCapacity} products, Max allowed (${this.algorithmConfig.maxCapacity}%): ${maxAllowedProducts} products`);
      
      while (availableOrders.length > 0 && orderCount < maxOrders) {
        // Find closest available order to the last assigned location
        let closestOrderIndex = -1;
        let closestDistance = Infinity;
        let closestOrder = null;
        
        for (let i = 0; i < availableOrders.length; i++) {
          const order = availableOrders[i];
          // Find this order's index in the original allPoints array
          const orderIndex = allPoints.findIndex(point => point.id === order.id);
          
          if (orderIndex !== -1) {
            const distance = matrix[lastAssignedIndex][orderIndex];
            if (distance < closestDistance) {
              closestDistance = distance;
              closestOrderIndex = i;
              closestOrder = order;
            }
          }
        }
        
        if (closestOrder === null) break;
        
        // Calculate fitting capacity for this order
        const fittingResult = this.calculateOrderFittingCapacity(closestOrder.data, vehicleGroup.vehicleId);
        
        // Check if adding this order would exceed capacity
        if (totalProductsInVehicle + fittingResult.totalProductsNeeded > maxAllowedProducts) {
          console.log(`  🚫 Product capacity limit reached for ${vehicleGroup.vehicleName}`);
          console.log(`    Current: ${totalProductsInVehicle} + Order: ${fittingResult.totalProductsNeeded} = ${totalProductsInVehicle + fittingResult.totalProductsNeeded}`);
          console.log(`    Max allowed (${this.algorithmConfig.maxCapacity}%): ${maxAllowedProducts} products`);
          break;
        }
        
        // Check if the order can fit completely in the vehicle
        if (!fittingResult.canFitCompletely) {
          console.log(`  ⚠️ Order ${closestOrder.data.number} cannot fit completely (needs ${fittingResult.totalProductsNeeded}, can fit ${fittingResult.totalProductsFit})`);
          // Skip this order for now, could be handled differently based on business rules
          availableOrders.splice(closestOrderIndex, 1);
          continue;
        }
        
        // Assign this order to the vehicle
        const bpbItem = this.createBpbItemWithFitting(closestOrder.data, fittingResult, 'Normal');
        console.log('bpb item', bpbItem);
        vehicleGroup.bpbList.push(bpbItem);
        vehicleGroup.bpbCount++;
        vehicleGroup.totalWeight += 10; // Estimated weight
        totalProductsInVehicle += fittingResult.totalProductsNeeded;
        orderCount++;
        
        // Update last assigned position for next iteration
        lastAssignedIndex = allPoints.findIndex(point => point.id === closestOrder.id);
        
        // Remove assigned order from available orders
        availableOrders.splice(closestOrderIndex, 1);
        
        console.log(`    ➡️ Assigned order ${closestOrder.data.number} (${fittingResult.totalProductsNeeded} products) - Distance: ${(closestDistance/1000).toFixed(2)}km`);
        console.log(`    📊 Current products: ${totalProductsInVehicle}/${maxAllowedProducts} (${((totalProductsInVehicle/maxAllowedProducts)*100).toFixed(1)}%)`);
      }
      
      // Update group statistics with the correct capacity calculation
      vehicleGroup.capacity = (totalProductsInVehicle / maxAllowedProducts) * 100;
      vehicleGroup.totalVolume = `${totalProductsInVehicle}/${maxProductsCapacity} products`;
      vehicleGroup.maxProductsCapacity = maxProductsCapacity;
      vehicleGroup.maxAllowedProducts = maxAllowedProducts;
      vehicleGroup.totalProductsInVehicle = totalProductsInVehicle;
      
      // Calculate estimated total route distance
      if (vehicleGroup.bpbList.length > 0) {
        vehicleGroup.estimatedDistance = this.calculateGroupRouteDistance(vehicleGroup, matrix, allPoints);
      }
      
      console.log(`  📊 Vehicle filled: ${vehicleGroup.bpbCount}/${maxOrders} orders, ${vehicleGroup.capacity.toFixed(1)}% capacity, ~${vehicleGroup.estimatedDistance}km route`);
    },

    // Calculate total route distance for a group
    calculateGroupRouteDistance(group, matrix, allPoints) {
      if (group.bpbList.length === 0) return 0;
      
      let totalDistance = 0;
      let currentIndex = 0; // Start from origin
      
      // Visit each order in the group in the order they were assigned
      for (const bpb of group.bpbList) {
        const orderIndex = allPoints.findIndex(point => 
          point.data && point.data.number === bpb.id
        );
        
        if (orderIndex !== -1) {
          totalDistance += matrix[currentIndex][orderIndex];
          currentIndex = orderIndex;
        }
      }
      
      // Return to origin (optional - uncomment if round trip is required)
      // totalDistance += matrix[currentIndex][0];
      
      return Math.round(totalDistance / 1000); // Convert to km
    },

    // Handle overflow orders that couldn't fit in initial vehicle assignments
    handleOverflowOrders(remainingOrders, selectedVehicles, finalGroups, groupCounter, matrix, allPoints, today) {
      let vehicleIndex = 0;
      
      while (remainingOrders.length > 0) {
        const vehicleId = selectedVehicles[vehicleIndex % selectedVehicles.length];
        const vehicle = this.vehicle.find(v => v.id === vehicleId);
        
        // Get vehicle fitting capacity
        const vehicleDimsCm = this.getVehicleDimensionsCm(vehicleId);
        const avgProductDims = { length: 29, width: 42, height: 15 };
        const maxFitResult = this.calculateFit(vehicleDimsCm, avgProductDims);
        const maxProductsCapacity = maxFitResult.totalFit;
        const maxAllowedProducts = Math.floor(maxProductsCapacity * this.algorithmConfig.maxCapacity / 100);
        
        console.log(`🔄 Creating overflow group for ${vehicle.name} (${this.algorithmConfig.maxCapacity}% capacity = ${maxAllowedProducts} products)`);
        
        // Create overflow group
        const overflowGroup = this.createVehicleGroup(
          groupCounter++,
          vehicleId,
          vehicle,
          null, // vehicleCapacity not used anymore
          maxAllowedProducts,
          today,
          `Kelompok ${vehicle.name} #${finalGroups.filter(g => g.vehicleId === vehicleId).length + 1} (Overflow)`
        );
        
        // Fill overflow group
        this.fillVehicleWithRouteOptimization(overflowGroup, remainingOrders, matrix, allPoints);
        
        if (overflowGroup.bpbList.length > 0) {
          // Mark as high priority since these are overflow
          overflowGroup.bpbList.forEach(bpb => bpb.priority = 'High');
          finalGroups.push(overflowGroup);
          console.log(`📦 Created overflow group for ${vehicle.name} with ${overflowGroup.bpbList.length} orders (${overflowGroup.capacity.toFixed(1)}% capacity)`);
        }
        
        vehicleIndex++;
        
        // Safety break to prevent infinite loop
        if (vehicleIndex > selectedVehicles.length * 10) {
          console.warn('⚠️ Breaking overflow handling to prevent infinite loop');
          break;
        }
      }
    },

    // Helper function to create a BPB item with fitting information
    createBpbItemWithFitting(order, fittingResult, priority) {
      // Create detailed dimensions display from fitting details
      let dimensionsDisplay = `${fittingResult.totalProductsNeeded} products`;
      if (fittingResult.fittingDetails && fittingResult.fittingDetails.length > 0) {
        const detailsText = fittingResult.fittingDetails.map(detail => 
          `(${detail.qty} items) ${detail.dimensions}`
        ).join(', ');
        dimensionsDisplay = detailsText;
      }
      
      return {
        id: order.number,
        id_bpb: order.id,
        customer: order.store_name,
        address: `${order.customer_shipping_province}, ${order.customer_shipping_city}, ${order.customer_shipping_subdistrict}`,
        supervisor: order.spv_name || 'N/A',
        sales: order.sales_name || 'N/A',
        dimensions: dimensionsDisplay,
        productsNeeded: fittingResult.totalProductsNeeded,
        productsFit: fittingResult.totalProductsFit,
        fittingPercentage: fittingResult.fittingPercentage,
        canFitCompletely: fittingResult.canFitCompletely,
        fittingDetails: fittingResult.fittingDetails,
        weight: '10 kg',
        priority: priority,
        order_input_datetime: order.order_input_datetime || 'N/A',
        coordinates: {
          lat: parseFloat(order.customer_latitude) || 0,
          lng: parseFloat(order.customer_longitude) || 0
        }
      };
    },

    // Helper function to create a BPB item (legacy method for compatibility)
    createBpbItem(order, orderVolume, priority) {
      return {
        id: order.number,
        customer: order.store_name,
        address: `${order.customer_shipping_province}, ${order.customer_shipping_city}, ${order.customer_shipping_subdistrict}`,
        supervisor: order.spv_name || 'N/A',
        sales: order.sales_name || 'N/A',
        dimensions: this.formatDimensions(orderVolume),
        volume: orderVolume,
        weight: '10 kg',
        priority: priority,
        order_input_datetime: order.order_input_datetime || 'N/A',
        coordinates: {
          lat: parseFloat(order.customer_latitude) || 0,
          lng: parseFloat(order.customer_longitude) || 0
        }
      };
    },

    // Convert millimeters to centimeters
    convertMmToCm(mm) {
      return mm / 10;
    },

    // Calculate how many products can fit in vehicle using 3D fitting (dimensions in cm)
    calculateFit(vehicleDimsCm, productDimsCm) {
      // Calculate how many products fit along each dimension
      const fitLength = Math.floor(vehicleDimsCm.length / productDimsCm.length);
      const fitWidth = Math.floor(vehicleDimsCm.width / productDimsCm.width);
      const fitHeight = Math.floor(vehicleDimsCm.height / productDimsCm.height);

      // Total products that fit
      const totalFit = fitLength * fitWidth * fitHeight;

      return {
        unit: 'cm',
        fitLength,
        fitWidth,
        fitHeight,
        totalFit,
        vehicleDimsCm,
        productDimsCm,
        vehicleVolume: vehicleDimsCm.length * vehicleDimsCm.width * vehicleDimsCm.height,
        productVolume: productDimsCm.length * productDimsCm.width * productDimsCm.height,
        efficiency: totalFit > 0 ? (totalFit * productDimsCm.length * productDimsCm.width * productDimsCm.height) / (vehicleDimsCm.length * vehicleDimsCm.width * vehicleDimsCm.height) * 100 : 0
      };
    },

    // Parse dimension string "DDxDDxDD" to dimension object in cm
    parseDimensions(dimensionString) {
      if (!dimensionString || dimensionString === '') {
        return { length: 0, width: 0, height: 0, volume: 0 };
      }
      
      const parts = dimensionString.split('x');
      if (parts.length !== 3) {
        return { length: 0, width: 0, height: 0, volume: 0 };
      }
      
      const length = parseInt(parts[0]) || 0;
      const width = parseInt(parts[1]) || 0;
      const height = parseInt(parts[2]) || 0;
      const volume = length * width * height;
      
      return { length, width, height, volume };
    },

    // Get vehicle dimensions in mm from vehicle data
    getVehicleDimensionsMm(vehicleId) {
      const vehicle = this.vehicle.find(v => v.id === vehicleId);
      if (!vehicle || !vehicle.volume) {
        // Default vehicle dimensions in mm (2430x1600x360)
        return { length: 2430, width: 1600, height: 360 };
      }
      
      const dimensions = this.parseDimensions(vehicle.volume);
      // Convert cm to mm for vehicle dimensions (assuming vehicle.volume is in cm)
      return {
        length: dimensions.length * 10, // cm to mm
        width: dimensions.width * 10,   // cm to mm
        height: dimensions.height * 10  // cm to mm
      };
    },

    // Calculate total fitting capacity for an order's products
    calculateOrderFittingCapacity(order, vehicleId) {
      const vehicleDimsCm = this.getVehicleDimensionsCm(vehicleId);
      
      let totalProductsNeeded = 0;
      let totalProductsFit = 0;
      let fittingDetails = [];
      
      // Check if order has bpb_detail with varian_volume
      if (order.bpb_detail && Array.isArray(order.bpb_detail)) {
        order.bpb_detail.forEach(detail => {
          if (detail.varian_volume) {
            const productDimsCm = this.parseDimensions(detail.varian_volume);
            const qty = parseInt(detail.bpb_detail_qty_dus) || parseInt(detail.bpb_detail_qty_pcs) || parseInt(detail.bpb_detail_qty_lusin) || 1;
            console.log(productDimsCm, "productDimsCm")
            if (productDimsCm.length > 0 && productDimsCm.width > 0 && productDimsCm.height > 0) {
              const fitResult = this.calculateFit(vehicleDimsCm, productDimsCm);
              
              totalProductsNeeded += qty;
              totalProductsFit += Math.min(qty, fitResult.totalFit); // Can't fit more than available
              
              fittingDetails.push({
                product: detail.varian_name || 'Unknown Product',
                dimensions: `${productDimsCm.length}x${productDimsCm.width}x${productDimsCm.height}cm`,
                qty: qty,
                canFit: fitResult.totalFit,
                actualFit: Math.min(qty, fitResult.totalFit),
                fitDetails: `${fitResult.fitLength}×${fitResult.fitWidth}×${fitResult.fitHeight}`
              });
            }
          }
        });
      }
      
      // If no detailed products, use estimated fitting
      if (totalProductsNeeded === 0) {
        // Assume average product size 29x42x15cm and 1 unit needed
        const avgProductDims = { length: 29, width: 42, height: 15 };
        const fitResult = this.calculateFit(vehicleDimsCm, avgProductDims);
        totalProductsNeeded = 1;
        totalProductsFit = fitResult.totalFit;
        
        fittingDetails.push({
          product: 'Estimated Product',
          dimensions: '29x42x15cm (estimated)',
          qty: 1,
          canFit: fitResult.totalFit,
          actualFit: fitResult.totalFit,
          fitDetails: `${fitResult.fitLength}×${fitResult.fitWidth}×${fitResult.fitHeight}`
        });
      }
      
      console.log(`Fitting Capacity for Order ${order.number}:`, {
        vehicleDimensions: vehicleDimsCm,
        totalProductsNeeded: totalProductsNeeded,
        totalProductsFit: totalProductsFit,
        canFitCompletely: totalProductsFit >= totalProductsNeeded,
        fittingDetails: fittingDetails
      });
      
      return {
        totalProductsNeeded,
        totalProductsFit,
        fittingPercentage: totalProductsNeeded > 0 ? (totalProductsFit / totalProductsNeeded) * 100 : 100,
        canFitCompletely: totalProductsFit >= totalProductsNeeded,
        fittingDetails
      };
    },

    // Calculate total volume for an order
    calculateOrderVolume(order) {
      let totalVolume = 0;
      
      // Check if order has bpb_detail with varian_volume
      if (order.bpb_detail && Array.isArray(order.bpb_detail)) {
        order.bpb_detail.forEach(detail => {
          if (detail.varian_volume) {
            const dimensions = this.parseDimensions(detail.varian_volume);
            totalVolume += dimensions.volume;
          }
        });
      }
      
      // If no volume data, use estimated volume
      if (totalVolume === 0) {
        totalVolume = 15000; // Default estimated volume per order
      }
      
      return totalVolume;
    },

    // Get vehicle volume capacity
    getVehicleCapacity(vehicleId) {
      const vehicle = this.vehicle.find(v => v.id === vehicleId);
      if (!vehicle) return 0;
      
      const volumeString = vehicle.volume || "280x140x163"; // Default volume
      const dimensions = this.parseDimensions(volumeString);
      return dimensions.volume;
    },

    // Format volume for display
    formatDimensions(volume) {
      if (volume === 0) return 'N/A';
      
      // Convert cubic cm to a readable format
      if (volume >= 1000000) {
        return `${(volume / 1000000).toFixed(1)}m³`;
      } else if (volume >= 1000) {
        return `${(volume / 1000).toFixed(1)}L`;
      } else {
        return `${volume}cm³`;
      }
    },

    createGroupsFromOrders() {
      // This method is now replaced by the new matrix-based distance + volume grouping algorithm
      // The actual grouping logic is handled by createVehicleBasedGroups method
      console.warn('createGroupsFromOrders is deprecated, use createVehicleBasedGroups instead');
      return [];
    },

    showRouteMap(group, index) {
      this.selectedGroupForMap = { ...group, index };
      this.routeMapDialog = true;
      
      // Initialize map after dialog opens
      this.$nextTick(() => {
        this.initializeMap();
      });
    },

    closeRouteMap() {
      if (this.map) {
        this.map.remove();
        this.map = null;
      }
      this.selectedGroupForMap = null;
      this.routeMapDialog = false;
    },

    initializeMap() {
      if (!window.maplibregl || !this.selectedGroupForMap) {
        console.error('MapLibre GL not loaded or no group selected');
        return;
      }

      // Wait for the map container to be available
      setTimeout(() => {
        const mapContainer = document.getElementById('route-map');
        if (!mapContainer) {
          console.error('Map container not found');
          return;
        }

        try {
          // Initialize the map
          this.map = new window.maplibregl.Map({
            container: 'route-map',
            style: {
              version: 8,
              sources: {
                'osm-tiles': {
                  type: 'raster',
                  tiles: [
                    'https://tile.openstreetmap.org/{z}/{x}/{y}.png'
                  ],
                  tileSize: 256,
                  attribution: '© OpenStreetMap contributors'
                }
              },
              layers: [
                {
                  id: 'osm-tiles',
                  type: 'raster',
                  source: 'osm-tiles'
                }
              ]
            },
            center: [this.originLocation.longitude, this.originLocation.latitude],
            zoom: 10
          });

          this.map.on('load', () => {
            this.addRouteToMap();
          });

        } catch (error) {
          console.error('Error initializing map:', error);
        }
      }, 500);
    },

    addRouteToMap() {
      if (!this.map || !this.selectedGroupForMap) return;

      const group = this.selectedGroupForMap;
      const coordinates = [];
      
      // Add origin point
      coordinates.push([this.originLocation.longitude, this.originLocation.latitude]);
      
      // Add delivery points
      group.bpbList.forEach(bpb => {
        if (bpb.coordinates && bpb.coordinates.lat && bpb.coordinates.lng) {
          coordinates.push([parseFloat(bpb.coordinates.lng), parseFloat(bpb.coordinates.lat)]);
        }
      });

      // Add route line
      this.map.addSource('route', {
        type: 'geojson',
        data: {
          type: 'Feature',
          properties: {},
          geometry: {
            type: 'LineString',
            coordinates: coordinates
          }
        }
      });

      this.map.addLayer({
        id: 'route',
        type: 'line',
        source: 'route',
        layout: {
          'line-join': 'round',
          'line-cap': 'round'
        },
        paint: {
          'line-color': '#3887be',
          'line-width': 3
        }
      });

      // Add markers
      this.addMarkersToMap();

      // Fit map to show all points
      this.fitMapToBounds(coordinates);
    },

    addMarkersToMap() {
      if (!this.map || !this.selectedGroupForMap) return;

      const group = this.selectedGroupForMap;

      // Add origin marker
      const originMarker = new window.maplibregl.Marker({ color: '#ff0000' })
        .setLngLat([this.originLocation.longitude, this.originLocation.latitude])
        .setPopup(new window.maplibregl.Popup().setHTML('<h4>Gudang (Origin)</h4>'))
        .addTo(this.map);

      // Add delivery markers
      group.bpbList.forEach((bpb, index) => {
        if (bpb.coordinates && bpb.coordinates.lat && bpb.coordinates.lng) {
          const marker = new window.maplibregl.Marker({ color: '#00ff00' })
            .setLngLat([parseFloat(bpb.coordinates.lng), parseFloat(bpb.coordinates.lat)])
            .setPopup(new window.maplibregl.Popup().setHTML(`
              <div>
                <h4>Stop ${index + 1}</h4>
                <p><strong>${bpb.customer}</strong></p>
                <p>${bpb.address}</p>
                <p>Volume: ${bpb.dimensions}</p>
              </div>
            `))
            .addTo(this.map);
        }
      });
    },

    fitMapToBounds(coordinates) {
      if (!this.map || coordinates.length === 0) return;

      const bounds = new window.maplibregl.LngLatBounds();
      coordinates.forEach(coord => bounds.extend(coord));
      
      this.map.fitBounds(bounds, {
        padding: 50,
        maxZoom: 15
      });
    },

    calculateRouteDistance() {
      if (!this.selectedGroupForMap) return 0;
      
      const group = this.selectedGroupForMap;
      let totalDistance = 0;
      let prevLat = this.originLocation.latitude;
      let prevLng = this.originLocation.longitude;

      group.bpbList.forEach(bpb => {
        if (bpb.coordinates && bpb.coordinates.lat && bpb.coordinates.lng) {
          const distance = this.calculateHaversineDistance(
            prevLat, prevLng,
            parseFloat(bpb.coordinates.lat), parseFloat(bpb.coordinates.lng)
          );
          totalDistance += distance;
          prevLat = parseFloat(bpb.coordinates.lat);
          prevLng = parseFloat(bpb.coordinates.lng);
        }
      });

      // Add distance back to origin
      if (group.bpbList.length > 0) {
        const lastBpb = group.bpbList[group.bpbList.length - 1];
        if (lastBpb.coordinates && lastBpb.coordinates.lat && lastBpb.coordinates.lng) {
          totalDistance += this.calculateHaversineDistance(
            parseFloat(lastBpb.coordinates.lat), parseFloat(lastBpb.coordinates.lng),
            this.originLocation.latitude, this.originLocation.longitude
          );
        }
      }

      return totalDistance;
    },

    calculateHaversineDistance(lat1, lng1, lat2, lng2) {
      const R = 6371000; // Earth's radius in meters
      const dLat = (lat2 - lat1) * Math.PI / 180;
      const dLng = (lng2 - lng1) * Math.PI / 180;
      const a = Math.sin(dLat/2) * Math.sin(dLat/2) +
              Math.cos(lat1 * Math.PI / 180) * Math.cos(lat2 * Math.PI / 180) *
              Math.sin(dLng/2) * Math.sin(dLng/2);
      const c = 2 * Math.atan2(Math.sqrt(a), Math.sqrt(1-a));
      return R * c; // Return distance in meters
    },

    // Get vehicle dimensions in cm from vehicle data
    getVehicleDimensionsCm(vehicleId) {
      const vehicle = this.vehicle.find(v => v.id === vehicleId);
      if (!vehicle || !vehicle.volume) {
        // Default vehicle dimensions in cm (243x160x36)
        return { length: 454, width: 192, height: 158 };
      }
      
      const dimensions = this.parseDimensions(vehicle.volume);
      // Return dimensions in cm (assuming vehicle.volume is already in cm)
      return {
        length: dimensions.length,
        width: dimensions.width,
        height: dimensions.height
      };
    },

    // Helper function to create a vehicle group
    createVehicleGroup(groupId, vehicleId, vehicle, vehicleCapacity, maxAllowedCapacity, today, customName = null) {
      // Get vehicle dimensions and calculate fitting capacity
      const vehicleDimsCm = this.getVehicleDimensionsCm(vehicleId);
      const avgProductDims = { length: 29, width: 42, height: 15 };
      const maxFitResult = this.calculateFit(vehicleDimsCm, avgProductDims);
      const maxProductsCapacity = maxFitResult.totalFit;
      const maxAllowedProducts = Math.floor(maxProductsCapacity * this.algorithmConfig.maxCapacity / 100);
      
      return {
        id: `group_${groupId}`,
        name: customName || `Kelompok ${vehicle.name} #${groupId}`,
        vehicleId: vehicleId,
        vehicleName: vehicle.name,
        vehicleNumber: vehicle.number,
        vehicleDimensions: `${vehicleDimsCm.length}×${vehicleDimsCm.width}×${vehicleDimsCm.height}cm`,
        maxProductsCapacity: maxProductsCapacity,
        maxAllowedProducts: maxAllowedProducts,
        totalProductsInVehicle: 0,
        bpbCount: 0,
        totalVolume: '0/0 products',
        totalWeight: 0,
        estimatedDistance: 0,
        capacity: 0,
        selectedVehicle: vehicleId,
        selectedDriver: null,
        deliveryDate: today,
        status: 'Incomplete',
        notes: '',
        bpbList: []
      };
    },

    // Get vehicle by ID helper method
    getVehicleById(vehicleId) {
      return this.vehicle.find(v => v.id === vehicleId);
    },

    // Remove vehicle from selection
    removeVehicle(item) {
      const index = this.selectedVehicles.indexOf(item.id);
      if (index > -1) {
        this.selectedVehicles.splice(index, 1);
      }
    },

    // Remove vehicle by ID
    removeVehicleById(vehicleId) {
      const index = this.selectedVehicles.indexOf(vehicleId);
      if (index > -1) {
        this.selectedVehicles.splice(index, 1);
      }
    },

    // Clear all selected vehicles
    clearSelectedVehicles() {
      this.selectedVehicles = [];
    },

    // Select all vehicles
    selectAllVehicles() {
      this.selectedVehicles = this.vehicle.map(v => v.id);
    },

    // Remove BPB from group
    removeBpbFromGroup(groupIndex, bpbIndex) {
      if (this.generatedGroups[groupIndex] && this.generatedGroups[groupIndex].bpbList[bpbIndex]) {
        const removedBpb = this.generatedGroups[groupIndex].bpbList[bpbIndex];
        const removedProductsCount = removedBpb.productsNeeded || 0;
        
        // Remove the BPB from the group
        this.generatedGroups[groupIndex].bpbList.splice(bpbIndex, 1);
        
        // Recalculate group capacity after removal
        this.recalculateGroupCapacity(this.generatedGroups[groupIndex]);
        
        // Force Vue reactivity update
        this.$forceUpdate();
        
        console.log(`🗑️ Removed BPB ${removedBpb.id} (${removedProductsCount} products) from group ${groupIndex}`);
      }
    },

    // Update group statistics after BPB removal
    updateGroupStatistics(groupIndex) {
      const group = this.generatedGroups[groupIndex];
      if (!group) return;

      let totalProducts = 0;
      let totalWeight = 0;

      group.bpbList.forEach(bpb => {
        if (bpb.productsNeeded) {
          totalProducts += bpb.productsNeeded;
        }
        // Assuming 10kg per order as default
        totalWeight += 10;
      });

      group.totalProductsInVehicle = totalProducts;
      group.totalWeight = totalWeight;
      group.totalVolume = `${totalProducts}/${group.maxProductsCapacity} products`;
      group.capacity = (totalProducts / group.maxAllowedProducts) * 100;
      
      // Update status based on completeness
      group.status = (group.selectedVehicle && group.selectedDriver) ? 'Complete' : 'Incomplete';
    },

    // Reset generation
    resetGeneration() {
      this.generatedGroups = [];
      this.updateStatistics();
    },

    // Confirm assignment
    async confirmAssignment() {
      this.process.confirming = true;
      
      try {
        // Simulate API call
        await new Promise(resolve => setTimeout(resolve, 2000));
        
        this.message.success = 'Assignment berhasil dikonfirmasi!';
        this.showSuccess = true;
        
        // Optionally redirect or reset form
        // this.$router.push('/delivery/surat-jalan');
        
      } catch (error) {
        console.error('Error confirming assignment:', error);
        this.message.error = 'Gagal mengkonfirmasi assignment';
        this.showError = true;
      } finally {
        this.process.confirming = false;
      }
    },

    // Calculate distance matrix using Haversine formula
    async calculateDistanceMatrix(orders) {
      const allPoints = [
        // Origin point (warehouse/depot)
        {
          id: 'origin',
          lat: this.originLocation.latitude,
          lng: this.originLocation.longitude,
          data: null
        }
      ]

      // Add all order points
      orders.forEach(order => {
        if (order.customer_latitude && order.customer_longitude) {
          allPoints.push({
            id: order.number,
            lat: parseFloat(order.customer_latitude),
            lng: parseFloat(order.customer_longitude),
            data: order
          });
        }
      });

      console.log(`📍 Calculating distance matrix for ${allPoints.length} points (including origin)`);

      // Create distance matrix
      const matrix = [];
      for (let i = 0; i < allPoints.length; i++) {
        matrix[i] = [];
        for (let j = 0; j < allPoints.length; j++) {
          if (i === j) {
            matrix[i][j] = 0;
          } else {
            const distance = this.calculateHaversineDistance(
              allPoints[i].lat, allPoints[i].lng,
              allPoints[j].lat, allPoints[j].lng
            );
            matrix[i][j] = distance;
          }
        }
      }

      console.log(`✅ Distance matrix calculated: ${matrix.length}x${matrix[0].length}`);
      return { matrix, allPoints };
    },

    // Add selected orders to group
    addSelectedOrdersToGroup() {
      if (!this.selectedGroupForAddBpb || this.selectedOrdersToAdd.length === 0) {
        return;
      }

      // Get the actual group from generatedGroups array using the index
      const actualGroup = this.generatedGroups[this.selectedGroupForAddBpb.index];
      if (!actualGroup) {
        console.error('Could not find actual group in generatedGroups array');
        return;
      }

      // Get the selected orders data
      const selectedOrders = this.order.filter(order => 
        this.selectedOrdersToAdd.includes(order.number)
      );

      let addedProductsCount = 0;

      // Add each selected order to the actual group
      selectedOrders.forEach(order => {
        // Calculate fitting capacity for this order
        const fittingResult = this.calculateOrderFittingCapacity(order, actualGroup.vehicleId);
        
        // Create BPB item with fitting information
        const bpbItem = this.createBpbItemWithFitting(order, fittingResult, 'Normal');
        
        // Add to actual group (not the copy)
        actualGroup.bpbList.push(bpbItem);
        
        // Count products added
        addedProductsCount += fittingResult.totalProductsNeeded;
      });

      // Recalculate group capacity after adding orders (using actual group)
      this.recalculateGroupCapacity(actualGroup, addedProductsCount);

      // Force Vue reactivity update
      this.$forceUpdate();

      // Show success message
      this.message.success = `Berhasil menambahkan ${selectedOrders.length} BPB ke ${actualGroup.name}`;
      this.showSuccess = true;

      // Reset and close modal
      this.selectedOrdersToAdd = [];
      this.selectAllUnassigned = false;
      this.closeAddBpbModal();
    },

    // Recalculate group capacity when orders are added
    recalculateGroupCapacity(group, addedProductsCount = 0) {
      let totalProducts = 0;
      let totalWeight = 0;

      // Calculate total products and weight from all BPB items
      group.bpbList.forEach(bpb => {
        if (bpb.productsNeeded) {
          totalProducts += bpb.productsNeeded;
        }
        // Assuming 10kg per order as default
        totalWeight += 10;
      });

      // Update group statistics
      group.bpbCount = group.bpbList.length;
      group.totalProductsInVehicle = totalProducts;
      group.totalWeight = totalWeight;
      group.totalVolume = `${totalProducts}/${group.maxProductsCapacity} products`;
      
      // Recalculate capacity percentage based on max allowed products
      if (group.maxAllowedProducts && group.maxAllowedProducts > 0) {
        group.capacity = (totalProducts / group.maxAllowedProducts) * 100;
      } else {
        group.capacity = 0;
      }

      console.log(`📊 Group ${group.name} capacity recalculated:`);
      console.log(`   Products: ${totalProducts}/${group.maxAllowedProducts} (${group.capacity.toFixed(1)}%)`);
      console.log(`   BPB Count: ${group.bpbCount}`);
      console.log(`   Total Weight: ${totalWeight}kg`);
    },

    // Update group statistics when vehicle/driver assignment changes
    updateGroupStatistics(groupIndex) {
      const group = this.generatedGroups[groupIndex];
      if (!group) return;

      // Recalculate capacity first
      this.recalculateGroupCapacity(group);
      
      // Update status based on vehicle and driver assignment
      group.status = (group.selectedVehicle && group.selectedDriver) ? 'Complete' : 'Incomplete';
      
      console.log(`🔄 Group statistics updated for ${group.name}:`);
      console.log(`   Status: ${group.status}`);
      console.log(`   Vehicle: ${group.selectedVehicle ? 'Assigned' : 'Not assigned'}`);
      console.log(`   Driver: ${group.selectedDriver ? 'Assigned' : 'Not assigned'}`);
    },

    closeAddBpbModal() {
      this.addBpbDialog = false;
      this.selectedGroupForAddBpb = null;
      this.addBpbSearch = '';
      this.selectedOrdersToAdd = [];
      this.selectAllUnassigned = false;
    },

    toggleSelectAllUnassigned() {
      if (this.selectAllUnassigned) {
        this.selectedOrdersToAdd = this.filteredUnassignedOrders.map(order => order.number);
      } else {
        this.selectedOrdersToAdd = [];
      }
    },

    checkOrderFitting(order) {
      if (!this.selectedGroupForAddBpb) {
        return true; // Default to true if no group selected
      }

      try {
        const fittingResult = this.calculateOrderFittingCapacity(order, this.selectedGroupForAddBpb.vehicleId);
        return fittingResult.canFitCompletely;
      } catch (error) {
        console.warn('Error checking order fitting:', error);
        return false;
      }
    },

    getQuantityText(detail) {
      const quantities = [];
      
      if (detail.bpb_detail_qty_dus && parseInt(detail.bpb_detail_qty_dus) > 0) {
        quantities.push(`${detail.bpb_detail_qty_dus} dus`);
      }
      if (detail.bpb_detail_qty_pcs && parseInt(detail.bpb_detail_qty_pcs) > 0) {
        quantities.push(`${detail.bpb_detail_qty_pcs} pcs`);
      }
      if (detail.bpb_detail_qty_lusin && parseInt(detail.bpb_detail_qty_lusin) > 0) {
        quantities.push(`${detail.bpb_detail_qty_lusin} lusin`);
      }

      return quantities.length > 0 ? quantities.join(', ') : '1 item';
    },

    openAddBpbModal(group, index) {
      this.selectedGroupForAddBpb = { ...group, index }; // Include index for reference
      this.addBpbDialog = true;
      this.selectedOrdersToAdd = [];
      this.selectAllUnassigned = false;
      this.addBpbSearch = '';
    },

    async toAddSurajJalan(group, index) {

      if (!group.selectedVehicle || !group.selectedDriver) {
        this.message.error = 'Mohon pilih kendaraan dan supir terlebih dahulu';
        this.showError = true;
        return;
      }

      if (!group.notes || group.notes.trim() === '') {
        this.message.error = 'Mohon isi catatan untuk Surat Jalan';
        this.showError = true;
        return;
      }
      

      let form = {
        date: group.deliveryDate,
        driver_id: group.selectedDriver,
        note: group.notes,
        vehicle_id: group.selectedVehicle,
        bpb_arr: JSON.stringify(group.bpbList.map(bpb => (bpb.id_bpb)))
      }
      this.process.form = true

      // SAVE TO REST API
      await post(`admin/surat_jalan/add`, {
        data: form
      })
      .then((response) => {
        let res = response.data

        this.process.form = false

        if (res.status === 200) {
          this.selected_suratjalan.push(index)
          this.message.success = `Berhasil menambahkan Surat Jalan`;
          this.showSuccess = true;
          this.process.form = false
        } else {
          this.message.error = res.message
        }
      })
    }
  }
}
</script>

<style scoped>
.color-primary {
  color: #1976d2 !important;
}

.color-success {
  color: #4caf50 !important;
}

.color-warning {
  color: #ff9800 !important;
}

.color-purple {
  color: #9c27b0 !important;
}

.color-error {
  color: #f44336 !important;
}

/* Custom table styling */
.v-data-table >>> .v-data-table__wrapper {
  border-radius: 8px;
  border: 1px solid #e0e0e0;
}

.v-simple-table >>> table {
  border-radius: 8px;
  overflow: hidden;
}

.v-simple-table >>> thead tr {
  background-color: #f5f5f5;
}

.v-simple-table >>> tbody tr:hover {
  background-color: #f9f9f9;
}

/* Custom expansion panel */
.v-expansion-panel >>> .v-expansion-panel-header {
  padding: 16px;
  min-height: auto;
}

.v-expansion-panel >>> .v-expansion-panel-content__wrap {
  padding: 0 16px 16px 16px;
}

/* Card hover effects */
.v-card {
  transition: all 0.3s ease;
}

.v-card:hover {
  box-shadow: 0 4px 12px rgba(0,0,0,0.1) !important;
}

/* Button customization */
.v-btn {
  text-transform: none !important;
  font-weight: 600;
}

/* Custom scrollbar */
::-webkit-scrollbar {
  width: 6px;
  height: 6px;
}

::-webkit-scrollbar-track {
  background: #f1f1f1;
  border-radius: 3px;
}

::-webkit-scrollbar-thumb {
  background: #c1c1c1;
  border-radius: 3px;
}

::-webkit-scrollbar-thumb:hover {
  background: #a8a8a8;
}

/* Modal table styling */
.bg-light-blue-1 {
  background-color: #e3f2fd !important;
}

.v-simple-table >>> tbody tr:hover {
  background-color: #f5f5f5 !important;
}

.v-simple-table >>> tbody tr.bg-light-blue-1:hover {
  background-color: #bbdefb !important;
}

/* Loading animation */
@keyframes rotate {
  from {
    transform: rotate(0deg);
  }
  to {
    transform: rotate(360deg);
  }
}

.rotating {
  animation: rotate 1s linear infinite;
}
</style> 